import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../common/components/form/form.module'



export default function OnespBasicInfoComponent({ handleInnerFormChange, id, selectedOnesp }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              isDisabled={id !== '0'}
              label="Phone"
              name="Phone"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Login.Phone',
                  selectedOnesp?.Login
                )
              }}
              type="number"
              value={selectedOnesp?.Login?.Phone}
            />
            <InputContainer
              isDisabled={id !== '0'}
              label="Email"
              name="Email"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Login.Email',
                  selectedOnesp?.Login
                )
              }}
              type="text"
              value={selectedOnesp?.Login?.Email}
            />
            {id === '0' && (
              <InputContainer
                icon
                label="Password"
                name="Password"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Login.Password',
                    selectedOnesp?.Login
                  )
                }}
                type="password"
                value={selectedOnesp?.Login?.Password}
              />)}
            {id === '0' && (
              <InputContainer
                icon
                label="Confirm Password"
                name="ConfirmPassword"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Login.ConfirmPassword',
                    selectedOnesp?.Login
                  )
                }}
                type="password"
                value={selectedOnesp?.Login?.ConfirmPassword}
              />
            )}


          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />

    </>
  )
}